import { render } from "./BaseDescktopView.vue?vue&type=template&id=219dc285&scoped=true"
import script from "./BaseDescktopView.vue?vue&type=script&lang=js"
export * from "./BaseDescktopView.vue?vue&type=script&lang=js"

import "./BaseDescktopView.vue?vue&type=style&index=0&id=219dc285&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219dc285"]])

export default __exports__